module.exports = __webpack_public_path__ + "media/dashboard/assets/images/hero/whatsapp-illustration-89dd442b6d38a4d7f80b3203bde1ee6d.svg";